'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {stopPropagation} from '../../../core-utilities/react-utils';


export function ModalView(props) {
  return (
    <div
      className={classNames("Modal ng-enter", props.className, props.animation, {
        'ng-enter-active': props.entered,
      })}
      style={props.style}
      ref={props.setDivRef}
      onClick={stopPropagation}
    >
      {props.children}
    </div>
  );
}

ModalView.propTypes = {
  className: T.string,
  animation: T.string,
  setDivRef: T.func,
};

ModalView.defaultProps = {
  animation: 'slide_in_up',
};



// WEBPACK FOOTER //
// ./src/js/components/modals/Modal/ModalView.js